import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { helpLink, UNIT, help, mainColor, SUPPORT_NUMBER } from '../../constants';
import Iframe from 'react-iframe';
import { withRouter } from 'react-router-dom';
import { BackButton } from '../../components';
import { styles } from './ContactSupport.styles';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchHotlineAvailability } from '../../apis/firebase';
import { isHotlineAvailable } from '../../utils/suitableDate';
import Spinner from '../Spinner';
function ContactSupport({ history, classes }) {
    const dispatch = useDispatch();
    const { hotlineAvailability } = useSelector(state => state.firebaseRealTime);
    const isHotlineEnabled = isHotlineAvailable(hotlineAvailability);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (hotlineAvailability === null) {
            dispatch(fetchHotlineAvailability())
                .finally(() => setIsLoading(false));
        } else {
            setIsLoading(false);
        }
    }, [dispatch, hotlineAvailability]);

    const bannerStyles: React.CSSProperties = {
        borderRadius: UNIT,
        border: '1px solid',
        padding: `16px 14px`,
        borderColor: isHotlineEnabled
            ? 'rgba(0, 153, 115, 0.25)'
            : 'rgba(255, 180, 0, 0.5)',
        backgroundColor: isHotlineEnabled
            ? 'rgba(0, 153, 115, 0.25)'
            : 'rgba(255, 180, 0, 0.25)'
    };

    return (


        <>
            <div className='px-4 pt-4'>
                <BackButton
                    className='p-0'
                    onClick={() => history.goBack()}
                    title={help.contactSupport.text}
                    subtitle={help.contactSupport.description}
                />

            </div>
            {isLoading ?
                <div
                    style={{
                        padding: UNIT * 5,
                        textAlign: 'center',
                        color: `rgba(${mainColor.rgb}, 1)`,
                        alignSelf: 'center',
                    }}
                >
                    <Spinner />
                </div> :
                <div className='px-4'>
                    <div className='d-flex flex-column  mt-2' style={bannerStyles}>
                        {isHotlineEnabled ? (
                            <p style={{ color: mainColor.colorBlack, fontSize: 12, fontWeight: 'bold' }}>
                                Notre assistance téléphonique est disponible. Pour une prise en charge de votre demande,  contactez-nous dès maintenant par téléphone au
                                <div className={classes.banner}>
                                    {SUPPORT_NUMBER}
                                </div>
                            </p>
                        ) : (
                            <p style={{ color: mainColor.colorBlack, fontSize: 12, fontWeight: 'bold' }}>
                                L'assistance téléphonique est actuellement indisponible. Veuillez privilégier
                                le formulaire de contact, notre équipe vous répondra rapidement.
                            </p>
                        )}
                    </div>
                    <div>
                        <Iframe
                            url={helpLink}
                            width='100%'
                            height='100%'
                            id='myId'
                            className={`${classes.viewStyle} border-0 pt-2`}
                            styles={{ height: 'calc(100vh - 238px)' }}
                        />

                    </div>
                </div>
            }
        </>
    );
};

export default withStyles(styles)(withRouter(ContactSupport));